import Modal from 'bootstrap/js/src/modal';

window.bootstrap = window.bootstrap || {};
window.bootstrap.Modal = Modal;

document.addEventListener('hidden.bs.modal', function(event) {
  // Remove the focus from the active element
  if (document.activeElement) {
    document.activeElement.blur();
  }
});
